module.exports = __webpack_public_path__ + "static/media/regal_ohne_flashe_markiert.041be699.jpg";